import React from 'react'
import useQueryParam from '../../../../../hooks/useQueryParam'
import { GROUPS_SORT_PARAM } from '../../../../../constants/query-params'
import {
    DEFAULT_TEXT_SUBMISSION_GROUPS_SORTING_TYPE,
    TextSubmissionGroupsSortingTypes,
} from '../../../../../constants/sorting-types'
import useQueryParamSetter from '../../../../../hooks/useQueryParamSetter'
import Text from 'antd/es/typography/Text'
import { Select } from 'antd'

const SortBySelect = () => {
    const sortParam = useQueryParam(GROUPS_SORT_PARAM) || DEFAULT_TEXT_SUBMISSION_GROUPS_SORTING_TYPE
    const setQueryParam = useQueryParamSetter()

    const sortingOptions = Object.keys(TextSubmissionGroupsSortingTypes).map(key => ({
        label: TextSubmissionGroupsSortingTypes[key].label,
        value: TextSubmissionGroupsSortingTypes[key].value,
    }))

    const handleSortChange = value => {
        setQueryParam({ [GROUPS_SORT_PARAM]: value })
    }

    return (
        <label className='d-flex-column'>
            <Text className='mb-4' type='secondary'>
                Sort by
            </Text>
            <Select
                value={sortParam}
                style={{ minWidth: 80 }}
                popupMatchSelectWidth={false}
                getPopupContainer={triggerNode => triggerNode.parentNode}
                showSearch
                optionFilterProp='label'
                onChange={handleSortChange}
                options={sortingOptions}
            />
        </label>
    )
}

export default SortBySelect
